import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-WindMapPreview';

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  borderRadius: 'inherit',
}));

export const WindMapPreview = () => (
  <Root>
    <img
      style={{ borderRadius: 'inherit', pointerEvents: 'none' }}
      src="/windmap.png"
      alt="Wind Map"
      width={195}
      height={145}
    />
  </Root>
);
